import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FooterLink } from '../../../types.ts';

export function useHistoryAndCatsController() {
  const { t } = useTranslation();

  const historyAndCatsText = t('footer.historyAndCats');

  const links: FooterLink[] = useMemo(() => {
    return [
      { id: 1, icon: 'telegram', link: 'https://t.me/+uQ2_pxUGA39lYjAy', text: 'ИиК 🧡' },
      { id: 2, icon: 'telegram', link: 'https://t.me/+NNkO0Ueb3Uc5MjMy', text: 'ОиК 💙' },
      { id: 3, icon: 'telegram', link: 'https://t.me/+bADmD4S45bs1NTRi', text: 'АиК 💜' },
      { id: 4, icon: 'telegram', link: 'https://t.me/+S2JMqnLJUeoxNTFi', text: 'ЛиК 💛' },
      { id: 5, icon: 'telegram', link: 'https://t.me/+v5Oy2PsbaqQ4OGRi', text: 'МиК 🩷' },
      { id: 6, icon: 'telegram', link: 'https://t.me/russianandcats', text: 'РиК ❤️' },
    ] as FooterLink[];
  }, []);

  return { historyAndCatsText, links };
}
